import { memo, useEffect, useState } from 'react';
import { bool, object, string, func, oneOfType, instanceOf } from 'prop-types';
import { equals } from 'ramda';
import { DatepickerInput, addDays, isPastDay } from '../../../ui/Datepicker';
import responsive from '../../../decorators/responsive';
import OverlayComponent from './Layout/Overlay';
import Attention from '../../../ui/Datepicker/components/Attention';
import * as Styled from './Style';
const Datepicker = ({
  id,
  scheduleBasePath,
  isRange = false,
  isHideControls = false,
  sm = false,
  isSelectedDatepickerRange = false,
  isSearchForm = false,
  hasBlankInputOnDefault = false,
  reSearch = Function.prototype,
  saveSelectedDate = Function.prototype,
  redirectToSchedule = Function.prototype,
  selectedDaysSingle = null,
  selectedDaysRange = {
    from: new Date(),
    to: new Date()
  },
  from,
  to,
  ...props
}) => {
  const isPopularDirectionPicker = equals(id, 'popularDirectionDatepicker');
  const [fromControls, setFromControls] = useState(false);
  const preparedSingleDate = isPastDay(new Date(`${selectedDaysSingle}T00:00`)) || !selectedDaysSingle ? new Date() : new Date(`${selectedDaysSingle}T00:00`);
  const isShownOverlayUnderField = !isSelectedDatepickerRange && !sm;
  let inputValue = '';
  if (selectedDaysSingle || !hasBlankInputOnDefault) {
    inputValue = isRange || isSelectedDatepickerRange ? {
      from,
      to
    } : preparedSingleDate;
  }
  const preparedDateFrom = d => {
    if (d) {
      if (isPastDay(new Date(d))) {
        return new Date();
      }
      return new Date(d);
    }
    return new Date();
  };
  const preparedDateTo = (fromDate, toDate) => {
    if (toDate) {
      if (isPastDay(new Date(toDate))) {
        return addDays({
          date: new Date(fromDate),
          count: 2
        });
      }
      return new Date(toDate);
    }
    return addDays({
      date: new Date(fromDate),
      count: 2
    });
  };
  const preparedRangeDate = {
    from: preparedDateFrom(selectedDaysRange.from),
    to: preparedDateTo(preparedDateFrom(selectedDaysRange.from), selectedDaysRange.to)
  };
  const onReSearch = () => {
    if (!sm && !isPopularDirectionPicker) {
      reSearch();
    }
  };
  const onSelectedDate = (day, isFromControls = false) => {
    saveSelectedDate(day);
    setFromControls(isFromControls);
    onReSearch();
  };
  useEffect(() => {
    if (isSearchForm) {
      saveSelectedDate(preparedSingleDate);
      saveSelectedDate(preparedRangeDate);
    }
  }, []);
  const Overlay = ({
    onCloseModal = Function.prototype
  }) => /*#__PURE__*/React.createElement(OverlayComponent, {
    onSelectedDate: onSelectedDate,
    allDaysOnClick: () => {
      redirectToSchedule([from, to]);
      onCloseModal();
    },
    selectedDays: preparedSingleDate,
    isShownControls: !isHideControls,
    scheduleBasePath: scheduleBasePath,
    onCloseModal: onCloseModal
  });
  const AttentionComponent = otherProps => /*#__PURE__*/React.createElement(Attention, {
    hasBottomGap: isSearchForm && sm,
    ...otherProps
  });
  return /*#__PURE__*/React.createElement(Styled.DatepickerWrapper, null, /*#__PURE__*/React.createElement(DatepickerInput, {
    isRange: isRange,
    id: id,
    labelInputName: I18n.t('layout.search.datepicker.date'),
    inputValue: inputValue,
    selectedDaysRange: preparedRangeDate,
    selectedDaysSingle: preparedSingleDate,
    onSelectedDate: onSelectedDate,
    isFromControls: fromControls,
    setFromControls: setFromControls,
    OverlayComponent: Overlay,
    isShownControls: !isHideControls,
    isSelectedDatepickerRange: isSelectedDatepickerRange,
    AttentionComponent: AttentionComponent,
    ...props
  }), isShownOverlayUnderField && /*#__PURE__*/React.createElement(Overlay, null));
};
Datepicker.propTypes = {
  id: string,
  scheduleBasePath: string,
  isSelectedDatepickerRange: bool,
  isRange: bool,
  sm: bool,
  isHideControls: bool,
  isSearchForm: bool,
  hasBlankInputOnDefault: bool,
  saveSelectedDate: func,
  redirectToSchedule: func,
  reSearch: func,
  onCloseModal: func,
  from: object,
  to: object,
  selectedDaysSingle: oneOfType([string, instanceOf(Date)]),
  selectedDaysRange: object
};
export default /*#__PURE__*/memo(responsive(Datepicker, ['sm']));